'use strict';

var detect = avastGlobals.detect,
	$link = $('.bi-download-link'),
	link = $link.attr('href'),
	splitted = link.split('='),
	newlink = splitted.join('=');

if (detect.os.isWindows && detect.os.version === 'XP' || detect.os.version === 'Vista') {
	splitted[1] = 'REM-XP';
	newlink = splitted.join('=');
	$link.attr('href', newlink).attr('data-bi-download-name', splitted[1]);
}
